import { useContext, useDebugValue } from "react";
// import AuthContext from "../context/AuthProvider";
import AuthContext from "../Context/AuthProvider";

const useAuth = () => {
    const { setAuth,auth } = useContext(AuthContext);
    useDebugValue(auth, auth => auth?.user ? "Logged In" : "Logged Out")
    return useContext(AuthContext);
}

export default useAuth;